import Component from '@cell/cell-core/component/component';

import './navigation.scss';

class Navigation extends Component {
  constructor() {
    super();

    this.handleOpen = this.handleOpen.bind(this);
    this.handleBackAction = this.handleBackAction.bind(this);
  }

  componentDidMount() {
    this.querySelectorAll(`details[data-level="${this.parsedDataset.level}"] > summary`).forEach(
      (summaryElement) => summaryElement.addEventListener('click', this.handleOpen),
    );

    this.on('c-button.click.back', this.handleBackAction);
  }

  handleOpen(event) {
    const detailsElement = event.currentTarget.parentNode;

    requestAnimationFrame(() => {
      detailsElement.setAttribute('aria-expanded', 'true');
    });
  }

  handleBackAction(event) {
    const detailsElement = event.target.closest('details');

    detailsElement.setAttribute('aria-expanded', 'false');

    setTimeout(() => {
      detailsElement.removeAttribute('open');
    }, 300);
  }
}

customElements.define('c-navigation', Navigation);
